export default {
  banner: [
    `<span class="font-black">Conheça </span><span style="font-family: Montserrat-thin; font-weight: 300;">nossos</span>`,
    'casos de sucesso',
  ],
}
